<app-tags
  [formControl]="formControl"
  [formlyAttributes]="field"
  [options]="props.options | optionWithObservable | async"
></app-tags>
